import { FC, ReactElement } from 'react'

import { Page } from '@/components'
import { ConnectedLeaveOfAbsences } from '@/connectors'

export const LeaveOfAbsencesPage: FC = (): ReactElement => (
    <Page className="leave-of-absences-page">
        <ConnectedLeaveOfAbsences />
    </Page>
)
